import BaseChartTooltip from "../../sisu/chart/BaseChartTooltip.sisu";

const NeoChartTooltip = BaseChartTooltip
export default NeoChartTooltip;